import { CountriesSelectionResp } from 'types/api/response/countries-selection-resp'

import { api } from './api'

export const getCountriesSelection = () => api.get<CountriesSelectionResp>('/country_selection')
